import { Currency, CurrencyAmount } from '@pancakeswap/sdk'
import { InjectedConnector } from 'wagmi/connectors/injected'

export const MOCK_WALLET_ENABLED = process.env.NEXT_PUBLIC_MOCK_WALLET === 'true'
export const MOCK_ACCOUNT = '0x1111111111111111111111111111111111111111' as `0x${string}`

// Fixed, human-friendly fake balance for theme QA (1,234 units of any token).
export function mockCurrencyAmount(currency: Currency): CurrencyAmount<Currency> {
  const whole = 1234n
  const raw = whole * 10n ** BigInt(currency.decimals)
  return CurrencyAmount.fromRawAmount(currency, raw.toString())
}

// Dev-only connector: a plain injected connector flagged so it is obvious in the UI/logs.
export function createMockConnector(chains: any[]) {
  return new InjectedConnector({
    chains,
    options: { name: 'Mock Wallet (dev)', shimDisconnect: false },
  })
}
